<template>
  <v-dialog
    overlay-color="grey darken-2"
    transition="scroll-x-transition"
    v-model="dialog"
    max-width="700"
    content-class="overflowY-hidden"
    persistent
  >
    <v-card class="accent" width="700px">
      <v-card-title
        style="background-color: #47bd96; color: white"
        :style="
          $vuetify.breakpoint.xsOnly ? 'text-align: center !important;' : ''
        "
        class="pageTitle"
        >New Chart</v-card-title
      >

      <v-stepper v-model="step" vertical flat class="chart-wizard">
        <v-stepper-step :complete="step > 1" step="1">
          Name
          <small>{{ newChart.name }}</small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-text-field
            v-model="newChart.name"
            dense
            outlined
            label="Chart Name"
            class="mt-2"
            style="width: 300px"
            @keydown="keyPressed"
          >
          </v-text-field>
        </v-stepper-content>

        <v-stepper-step :complete="step > 2" step="2">
          Type
          <!-- <small>{{ newChart.symbols }}</small> -->
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-row no-gutters>
            <v-col sm="4" cols="12">
              <v-row no-gutters justify="center">
                <v-icon
                  x-small
                  :class="{
                    'primary--text': isChart,
                  }"
                  class="mr-1"
                  >fas fa-chart-line</v-icon
                >
                <p
                  :class="{
                    'primary--text': isChart,
                  }"
                  class="text-center mb-0"
                >
                  Chart
                </p>
              </v-row>
              <v-btn
                @click="newChart.type = VISUALIZATION_TYPES.CHART"
                text
                height="120"
              >
                <v-img
                  src="../../assets/views-images/pricewatcher/chart.png"
                  :aspect-ratio="18 / 9"
                  width="185"
                ></v-img>
                <i
                  v-if="isChart"
                  class="primary--text fas fa-check-circle"
                  style="position: absolute; font-size: 26px"
                ></i>
              </v-btn>
            </v-col>

            <v-col
              sm="4"
              cols="12"
              :class="{ 'pl-4': $vuetify.breakpoint.smAndUp }"
            >
              <v-row no-gutters justify="center">
                <v-icon
                  x-small
                  :class="{
                    'primary--text':
                      newChart.type === VISUALIZATION_TYPES.LIVE_TABLE,
                  }"
                  class="mr-1"
                  >fas fa-broadcast-tower</v-icon
                >
                <p
                  :class="{
                    'primary--text':
                      newChart.type === VISUALIZATION_TYPES.LIVE_TABLE,
                  }"
                  class="text-center mb-0"
                >
                  Live Table
                </p>
              </v-row>
              <v-btn
                @click="newChart.type = VISUALIZATION_TYPES.LIVE_TABLE"
                text
                height="120"
                class="px-2"
              >
                <v-img
                  src="../../assets/views-images/pricewatcher/table_live.png"
                  :aspect-ratio="18 / 9"
                  width="185"
                ></v-img>
                <i
                  v-if="newChart.type === VISUALIZATION_TYPES.LIVE_TABLE"
                  class="primary--text fas fa-check-circle"
                  style="position: absolute; font-size: 26px"
                ></i>
              </v-btn>
            </v-col>
            <v-col sm="4" cols="12">
              <v-row no-gutters justify="center" style="position: relative">
                <!-- <div id="overlay" onclick="off()"></div> -->
                <v-icon
                  x-small
                  :class="{
                    'primary--text': isHistoricalTable,
                  }"
                  class="mr-1"
                  color="grey"
                  >fa-solid fa-clock-rotate-left</v-icon
                >
                <p
                  :class="{
                    'primary--text': isHistoricalTable,
                  }"
                  class="text-center mb-0 grey--text"
                >
                  Historical Table
                </p>
              </v-row>
              <v-row justify="center">
                <v-btn
                  @click="newChart.type = VISUALIZATION_TYPES.HISTORY_TABLE"
                  disabled
                  text
                  height="120"
                  class="px-6"
                  stle="width:150px !important;"
                >
                  <v-row justify="center">
                    <v-img
                      src="../../assets/views-images/pricewatcher/table.png"
                      :aspect-ratio="13 / 9"
                      width="140"
                    ></v-img>
                  </v-row>
                  <i
                    v-if="isHistoricalTable"
                    class="primary--text fas fa-check-circle"
                    style="position: absolute; font-size: 26px"
                  ></i>
                  <v-overlay disabled :absolute="true" :value="true">
                  </v-overlay>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-stepper-content>

        <transition name="fade">
          <!-- :rules="[() => isChart || isHistoricalTable]" -->
          <v-stepper-step
            :complete="step > 3"
            error-icon="fa-solid fa-circle-xmark"
            step="3"
          >
            Watcher{{ isHistoricalTable ? "" : "s" }}
            <small>{{
              newChart.watchers.length ? newChart.watchers.length : ""
            }}</small>
          </v-stepper-step>
        </transition>

        <transition name="fade">
          <v-stepper-content step="3">
            <!-- <v-select
              v-if="isHistoricalTable"
              dense
              outlined
              v-model="newChart.watchers"
              :items="processedWatchers"
              item-value="id"
              item-text="name"
              :menu-props="{ offsetY: true, maxHeight: '250' }"
              label="Watcher"
              class="mt-2"
              style="width: 300px"
            >
              <template v-slot:item="{ item }">
                <div class="mb-0 char-lim-tabs">
                  <div>{{ item.name }}</div>
                </div>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1">
                  (+{{ newChart.watchers.length - 1 }}
                  others)
                </span>
              </template>
              <template v-slot:prepend-item>
                <v-list-item
                  style="max-height: 40px; border-bottom: 1px solid #7f7f7f"
                  ripple
                  @click="selectAllWatchers"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      :class="
                        newChart.watchers.length == watchers.length
                          ? 'primary--text'
                          : $vuetify.theme.dark
                          ? 'white--text'
                          : 'black--text'
                      "
                      style="font-size: 16px !important; font-weight: 400"
                      >Select All</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select> -->
            <v-select
              dense
              outlined
              v-model="newChart.watchers"
              :items="watchers"
              item-value="id"
              item-text="name"
              multiple
              :menu-props="{ offsetY: true, maxHeight: '250' }"
              label="Watchers"
              class="mt-2"
              style="width: 300px"
            >
              <template v-slot:item="{ item }">
                <!-- <v-hover v-slot="{ hover }">
                  <div style="height: 100%; width: 100%">
                       -->
                <div :class="{ 'grey--text': item.appStatus !== 'RUN' }">
                  {{ item.name }}
                </div>
                <!--
                    <v-subheader
                      v-if="item.appStatus != 'RUN'"
                      v-show="hover"
                      style="position: absolute; bottom: -14px; left: 8px"
                    >
                      Not running
                    </v-subheader>
                  </div>
                </v-hover> -->
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1">
                  (+{{ newChart.watchers.length - 1 }}
                  others)
                </span>
              </template>
              <template v-slot:prepend-item>
                <v-list-item
                  style="max-height: 40px; border-bottom: 1px solid #7f7f7f"
                  ripple
                  @click="selectAllWatchers"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      :class="
                        newChart.watchers.length === watchers.length
                          ? 'primary--text'
                          : $vuetify.theme.dark
                          ? 'white--text'
                          : 'black--text'
                      "
                      style="font-size: 16px !important; font-weight: 400"
                      >Select All</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
            <!-- item-text="name"
              item-value="id" -->
          </v-stepper-content>
        </transition>

        <transition name="fade">
          <v-stepper-step step="4" error-icon="fa-solid fa-circle-xmark"
            >Symbol
          </v-stepper-step>
        </transition>
        <transition name="fade">
          <v-stepper-content step="4" class="pl-3" style="padding-right: 30px">
            <v-autocomplete
              v-model="newChart.symbols"
              :items="symbols"
              :multiple="newChart.type === VISUALIZATION_TYPES.LIVE_TABLE"
              dense
              outlined
              label="Symbol"
              class="mt-2"
              style="width: 300px"
              no-data-text="No common symbols in selected watchers"
              icon
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index === 1">
                  (+{{ newChart.symbols.length - 1 }}
                  others)
                </span>
              </template>
              <template v-slot:item="{ item, attrs }">
                <div style="font-size: 0.875rem">
                  <v-icon
                    :color="!attrs.inputValue ? 'white' : 'primary'"
                    class="mr-1"
                  >
                    {{
                      attrs.inputValue
                        ? "radio_button_checked"
                        : "radio_button_unchecked"
                    }}
                  </v-icon>
                  {{ item }}
                </div>
                <!-- <div class="mb-0 char-lim-tabs">
                  <div>{{ item.name }}</div>
                </div> -->
              </template>
            </v-autocomplete>
          </v-stepper-content>
        </transition>
        <template v-if="isAdmin">
          <transition name="fade">
            <v-stepper-step step="5" error-icon="fa-solid fa-circle-xmark"
            >Visibility
            </v-stepper-step>
          </transition>
          <transition name="fade">
            <v-stepper-content step="5" class="pl-3" style="padding-right: 30px">
              <input-wrapper>
                <v-switch
                    v-model="newChart.isPublic"
                    :label="`${newChart.isPublic ? 'Public' : 'Private'}`"
                    hide-details
                    dense
                />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">fa fa-info-circle</v-icon>
                  </template>
                  <span>Specify if the chart will also be visible to regular users or only to Admin and to the owner of the chart</span>
                </v-tooltip>
              </input-wrapper>
            </v-stepper-content>
          </transition>
        </template>
      </v-stepper>

      <v-row class="mx-0 accent" justify="space-between">
        <v-btn class="ma-2 opacity-1-slow" text @click="dialog = false"
        >Cancel
        </v-btn
        >
        <v-btn
            :disabled="step === 1"
            class="my-2 opacity-1-slow"
            text
            @click="step--"
        >
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            v-if="showCreateBtn"
            @click="createNew"
            color="primary"
            class="ma-2"
        >Create
        </v-btn
        >
        <div v-else @click="continueWizard">
          <v-btn class="ma-2" color="primary">Continue</v-btn>
        </div>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { defaultChart } from "@/utilities/DefaultObjects.js";
import { VISUALIZATION_TYPES } from "@/utilities/enums";
import {mapGetters} from "vuex";
import InputWrapper from "@/components/UI/InputWrapper.vue";
export default {
  name: "ChartWizard",
  components: {InputWrapper},
  // components: {
  //   VChart,
  // },
  mounted() {
    this.newChart.type = VISUALIZATION_TYPES.CHART;
    // TODO
    // processedWatchers are the watchers with a "selectable" option
    // which is true when a watcher has at least one watched symbol
    // If its true then the watcher can be selected on the v-select, otherwise not.
  },
  data: () => ({
    VISUALIZATION_TYPES: VISUALIZATION_TYPES,
    processedWatchers: [],
    newChart: {
      name: "",
      symbols: "",
      watchers: [],
      type: null,
      isPublic: false,
    },
    symbols: [],
    step: 1,
  }),
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    watchers: {
      type: Array,
      default: () => [],
    },
    definitions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getFullIdentity(definition) {
      let stringID = definition.id.toString();
      let numberOfDigits = stringID.length;
      switch (numberOfDigits) {
        case 1:
          stringID = "00" + stringID;
          break;
        case 2:
          stringID = "0" + stringID;
          break;
      }

      return definition.application.code + stringID;
    },
    // processWatchers() {
    //   this.processedWatchers = this.watchers.map((watcher, i) => {
    //     // watcher.disabled = true;
    //     let definition = this.definitions.find(
    //       (def) => this.getFullIdentity(def) == watcher.id
    //       // (def) => def.application.code + def.id == watcher.id
    //     );
    //     if (!definition) {
    //       return;
    //     }

    //     if (
    //       typeof definition.configuration.watched_symbols == "object" &&
    //       definition.configuration.watched_symbols.length
    //     ) {
    //       watcher.disabled = false;
    //     }
    //   });
    // },
    getSymbolsForLiveTable() {
      let symbols = [];
      let definitions = this.definitions.filter((el) =>
        this.newChart.watchers.includes(this.getFullIdentity(el))
      );
      let arraysOfSymbols = definitions.reduce((final, next) => {
        let symbols = next.configuration.watched_symbols;
        if (symbols.length) final.push(symbols);
        return final;
      }, []);
      // Create a new array from array of arrays of strings without duplicates
      symbols = [...new Set([...arraysOfSymbols.flat()])];
      return symbols;
    },
    getCommonSymbols(mainArray, secondaryArary) {
      return mainArray.filter((el) =>
        secondaryArary.some((item) => item === el)
      );
    },
    setSymbols() {
      try {
        let watcherDefinitions = this.definitions.filter((el) => {
          let identity = this.getFullIdentity(el);
          return this.newChart.watchers.includes(identity);
        });

        // Convert all symbol objects to strings (in all watcher definitions)
        // e.g {name: "XAUUSD", alias: "GOLD"} => "GOLD"
        watcherDefinitions = watcherDefinitions.map((el) => {
          let watched_symbols = el.configuration.watched_symbols;
          if (watched_symbols.length && typeof watched_symbols[0] == "object") {
            watched_symbols = watched_symbols.map((symbol) => {
              return symbol.hasOwnProperty("alias")
                ? symbol.alias
                : symbol.name;
            });
            el.configuration.watched_symbols = watched_symbols;
          }
          return el;
        });

        if (this.newChart.type === VISUALIZATION_TYPES.CHART) {
          let commonSymbols =
            watcherDefinitions[0].configuration.watched_symbols;
          watcherDefinitions.forEach((el) => {
            commonSymbols = this.getCommonSymbols(
              commonSymbols,
              el.configuration.watched_symbols
            );
          });
          // if (
          //   commonSymbols &&
          //   commonSymbols.length &&
          //   typeof commonSymbols[0] == "object"
          // ) {
          //   commonSymbols = commonSymbols.map((el) =>
          //     el.hasOwnProperty("alias") ? el.alias : el.name
          //   );
          // }

          this.symbols = commonSymbols.sort();
        } else if (this.newChart.type === VISUALIZATION_TYPES.LIVE_TABLE) {
          this.symbols = this.getSymbolsForLiveTable().sort();
          // this.symbols = symbols of all watchers (not common, just all but without duplicates)
          // see how you do it in LivePriceChart component
        }
      } catch (error) {
        console.error(error);
      }

      // Find commonSymbols
    },
    selectAllWatchers() {
      if (this.newChart.watchers.length === this.watchers.length)
        this.newChart.watchers = [];
      else this.newChart.watchers = this.watchers.map((el) => el.id);
    },
    clearDialog() {
      this.newChart = {
        name: "",
        symbols: "",
        watchers: "",
        type: VISUALIZATION_TYPES.CHART,
      };
      this.step = 1;
    },
    keyPressed(ev) {
      if (ev.keyCode === 13 && ev.which === 13) this.continueWizard();
    },
    continueWizard() {
      // if (!this.isChart && !this.isHistoricalTable) return;
      switch (this.step) {
        case 1:
          if (
            typeof this.newChart.name == "string" &&
            this.newChart.name.length
          )
            this.step++;
          break;
        case 2:
          this.step++;
          break;
        case 3:
          this.setSymbols();
          this.step++;
          break;
        default:
          this.step++;
      }
    },
    createNew() {
      // TODO remove the following workaround
      // In case of live table 'symbol' should become 'symbols'

      // if (this.newChart.type == VISUALIZATION_TYPES.LIVE_TABLE) {
      //   this.newChart.symbols = this.newChart.symbols;
      //   delete this.newChart.symbols;
      // }
      this.$emit("create", JSON.parse(JSON.stringify(this.newChart)));
      this.newChart = JSON.parse(JSON.stringify(defaultChart));
      this.step = 1;
      this.dialog = false;
    },
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    showCreateBtn() {
      let isLastStep = this.step === (this.isAdmin ? 5 : 4);
      let lastHistoricalTableStep = this.step === 3 && this.isHistoricalTable;
      // let lastLiveTableStep =
      //   !this.isChart && !this.isHistoricalTable && this.step > 2;
      return isLastStep || lastHistoricalTableStep;
      // return isLastStep || lastHistoricalTableStep || lastLiveTableStep;
    },
    isChart() {
      return this.newChart.type === VISUALIZATION_TYPES.CHART;
    },
    isHistoricalTable() {
      return this.newChart.type === VISUALIZATION_TYPES.HISTORY_TABLE;
    },
    dialog: {
      get() {
        return this.value;
      },
      set(ev) {
        this.$emit("input", ev);
      },
    },
  },
  watch: {
    dialog(v) {
      if (!v) this.clearDialog();
      // else {
      //   // Wizard opened
      //   this.processWatchers();
      // }
    },
  },
};
</script>
<style scoped></style>
<style>
/* #overlay {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 2;
  cursor: pointer;
} */
.chart-wizard .error--text div {
  color: grey !important;
}
.chart-wizard .error--text i {
  color: grey !important;
}
</style>
